import { Component } from '@angular/core';
import { RailroadSubCode } from '../api';
import {
	FormConfig,
	CustomFormAccessor,
} from '../form-models/form-cva.component';
import { Validators, NgControl, FormBuilder } from '@angular/forms';

export const railroadSubCodeFormConfig: FormConfig<Required<
	RailroadSubCode
>> = {
	id: [''],
	railroad: [''],
	code: ['', Validators.required],
	sortOrder: [''],
};

@Component({
	selector: 'rpshared-railroad-sub-code',
	templateUrl: './railroad-sub-code.component.html',
})
export class RailroadSubCodeComponent extends CustomFormAccessor<
	RailroadSubCode
> {
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, railroadSubCodeFormConfig);
	}

	// model --> view
	writeValue(value: RailroadSubCode): void {
		super.writeValue(value);
	}

	// view --> model
	registerOnChange(fn: (value: RailroadSubCode) => void) {
		super.registerOnChange(fn);
	}
}
